<div class="container mt-30">
  <fgbcl-auction-list [defaultSort]="1"></fgbcl-auction-list>
</div>
